import React, {Fragment} from "react";
import {Col, Image, Row} from "react-bootstrap";
import CardStatistics from "./CardStatistics";
import Player from "../../../../assets/img/demo/player-avatar-7.png";

const PlayerCard = props => {
    const {player} = props;
    const {name, avatar, teamName, position, birthCountry} = player;
    const {overallScore, age, weight, height, foot} = player;
    const {matchesPlayed, goalsScored, assists} = player;

    return (
        <div className="player-wrapper">
            <div className="player">
                <Image src={avatar} roundedCircle/>
                <div className="player-info">
                    <h2 className="player-name">{name}</h2>
                    <p className="player-detail">{`${position} | ${teamName} | ${birthCountry}`}</p>
                </div>
            </div>
            <div className="player-statistics">
                <div className="statistics-list">
                    <h3 className="category">General Details</h3>
                    <div className="statistics">
                        <CardStatistics title="Overall Score" value={overallScore}/>
                        <CardStatistics title="Age" value={age}/>
                        <CardStatistics title="Weight" value={weight}/>
                        <CardStatistics title="Height" value={height}/>
                        <CardStatistics title="Foot" value={foot}/>
                    </div>
                </div>
                <div className="statistics-list">
                    <h3 className="category">Matches Played</h3>
                    <div className="statistics">
                        <CardStatistics title="Total" value={matchesPlayed} status="green"/>
                        <CardStatistics title="International" value={"100"} status="green"/>
                        <CardStatistics title="Home" value="30"/>
                    </div>
                </div>
                <div className="statistics-list">
                    <h3 className="category">Goals Scored</h3>
                    <div className="statistics">
                        <CardStatistics title="Total" value={goalsScored}/>
                        <CardStatistics title="International" value="30" status="green"/>
                        <CardStatistics title="Home" value="15"/>
                    </div>
                </div>
                <div className="statistics-list">
                    <h3 className="category">Assist</h3>
                    <div className="statistics">
                        <CardStatistics title="Total" value={assists} status="green"/>
                        <CardStatistics title="International" value="10" status="green"/>
                        <CardStatistics title="Home" value="20"/>
                    </div>
                </div>
                <div className="statistics-list">
                    <h3 className="category">Strength</h3>
                    <div className="statistics">
                        <CardStatistics title="Shooting" value="93"/>
                        <CardStatistics title="Passing" value="89"/>
                        <CardStatistics title="Dribble" value="87"/>
                    </div>
                </div>
                <div className="statistics-list">
                    <h3 className="category">Weakness</h3>
                    <div className="statistics">
                        <CardStatistics title="Dribble" value="30"/>
                        <CardStatistics title="Key Passing" value="32"/>
                        <CardStatistics title="Tackel" value="34"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerCard;
